/* The Jacket, in the hand: pull the broken-heart zip down to open it and find the numbered label
   inside, and a soft light that follows the cursor (or the tilt of the phone) across the leather. */
(function () {
  var sec = document.querySelector('[data-drop]'), stage = sec && sec.querySelector('[data-stage]');
  if (!stage || stage.dataset.unzip) return;
  var face = stage.querySelector('.sa-stage__face--front'), home = face && face.querySelector('img');
  if (!home) return;
  stage.dataset.unzip = '1';
  var me = document.currentScript && document.currentScript.src || '';
  var ASSET = me.indexOf('sa-unzip.js') > -1 ? me.split('sa-unzip.js')[0] : '';
  var CX = 50.9, TOP = 18.5, FROM = 22, TO = 84.3;   /* the zip on the front photograph, as % of the picture */
  var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function el(tag, cls, txt) { var n = document.createElement(tag); if (cls) n.className = cls; if (txt) n.textContent = txt; return n; }
  function clamp(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
  function seg(p, a, b) { return clamp((p - a) / (b - a)); }

  var css = el('style');
  css.textContent = '.sa-uz{position:absolute;inset:0;z-index:1;pointer-events:none}' +
    '.sa-uz__in{position:absolute;inset:0;visibility:hidden;background:#17171a;background-size:230% auto;background-position:0 50%}' +
    '.sa-uz__shade{position:absolute;inset:0;filter:blur(7px)}.sa-uz__shade i{position:absolute;inset:0;background:rgba(0,0,0,.92)}' +
    '.sa-uz__tag{position:absolute;left:' + CX + '%;top:28%;width:29%;transform:translate(-50%,0) rotate(-2deg);padding:7.5% 0;background:#111113;border:1px solid rgba(214,203,178,.28);outline:1px solid rgba(0,0,0,.6);outline-offset:2px;box-shadow:0 3px 8px rgba(0,0,0,.6);text-align:center;opacity:0;color:#d6cbb2;font:400 clamp(9px,3.5cqw,14px)/1 Cormorant Garamond,Georgia,serif;letter-spacing:.08em;white-space:nowrap}' +
    '.sa-uz__tag small{display:block;margin-top:.5em;font-size:.62em;letter-spacing:.06em;opacity:.7}' +
    '.sa-uz__tape{position:absolute;inset:0;visibility:hidden;background:linear-gradient(180deg,#d8d3ca,#8d8880 60%,#6f6b65)}' +
    '.sa-uz__pull{position:absolute;z-index:3;left:' + CX + '%;width:44px;height:44px;margin:-22px 0 0 -22px;padding:0;border:0;background:none;color:inherit;cursor:grab;touch-action:none;-webkit-tap-highlight-color:transparent;appearance:none;-webkit-appearance:none}' +
    '.sa-uz__pull:active{cursor:grabbing}' +
    '.sa-uz__pull svg{position:absolute;left:50%;top:50%;width:19px;margin:-11px 0 0 -9.5px;fill:#d9d5ce;filter:drop-shadow(0 1px 2px rgba(0,0,0,.7));opacity:0;transition:opacity .2s}' +
    '.sa-uz.is-live ~ .sa-uz__pull svg{opacity:1}' +
    '.sa-uz__ring{position:absolute;left:50%;top:50%;width:30px;height:30px;margin:-15px 0 0 -15px;border:1px solid currentColor;border-radius:50%;opacity:0;pointer-events:none}' +
    '.sa-uz__pull:not(.is-used) .sa-uz__ring{animation:sa-uz-ring 2.4s ease-out infinite}' +
    '.sa-uz__pull:focus-visible .sa-uz__ring{opacity:.9;animation:none}' +
    '.sa-uz__say{position:absolute;left:100%;top:50%;margin:-7px 0 0 2px;font:400 9px/14px IBM Plex Mono,ui-monospace,monospace;letter-spacing:.22em;text-transform:uppercase;white-space:nowrap;opacity:.7;pointer-events:none;transition:opacity .4s}' +
    '.sa-uz__pull.is-used .sa-uz__say{opacity:0}' +
    '@keyframes sa-uz-ring{0%{transform:scale(.55);opacity:0}25%{opacity:.75}100%{transform:scale(1.5);opacity:0}}' +
    '.sa-stage__face:not(.is-active) .sa-uz__pull{display:none}' +
    '.sa-stage.is-dragging .sa-uz__pull{opacity:0}' +
    '.sa-sheen{position:absolute;inset:0;z-index:2;pointer-events:none;mix-blend-mode:screen;opacity:0;transition:opacity .8s;background:radial-gradient(circle at var(--lx,32%) var(--ly,26%),rgba(255,248,236,.36) 0,rgba(255,248,236,.13) 20%,transparent 44%);-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat;-webkit-mask-position:center;mask-position:center;-webkit-mask-size:contain;mask-size:contain}' +
    '.sa-stage.is-lit .sa-sheen{opacity:1}' +
    '@media (prefers-reduced-motion:reduce){.sa-uz__pull:not(.is-used) .sa-uz__ring{animation:none;opacity:.6}}';
  document.head.appendChild(css);

  /* the number on the label: the next one in the run, from live stock */
  var RUN = 117, left = typeof window.SA_LEFT === 'number' ? window.SA_LEFT : -1, next = left > 0 ? Math.max(1, Math.min(RUN, RUN - left + 1)) : 1;
  function pad(n) { return (n < 10 ? '00' : n < 100 ? '0' : '') + n; }

  var box = el('div', 'sa-uz'), inside = el('div', 'sa-uz__in'), tag = el('div', 'sa-uz__tag', 'No. ' + pad(next) + ' / ' + RUN), small = el('small', '', 'proof you were here.');
  box.style.containerType = 'inline-size';
  if (ASSET) inside.style.backgroundImage = 'url(' + ASSET + 'sa-jacket-lining.jpg)';
  /* the leather casts a soft shadow onto the lining along both edges of the opening */
  var shade = el('div', 'sa-uz__shade'), rim = el('i'); shade.appendChild(rim); inside.appendChild(shade);
  tag.appendChild(small); inside.appendChild(tag);
  var tape = el('div', 'sa-uz__tape');
  box.appendChild(tape); box.appendChild(inside);
  var pull = el('button', 'sa-uz__pull'), ring = el('span', 'sa-uz__ring'), say = el('span', 'sa-uz__say', 'Pull');
  pull.type = 'button'; pull.setAttribute('aria-label', 'Unzip the jacket'); pull.setAttribute('aria-pressed', 'false');
  var heart = sec.querySelector('.sa-zip__pull svg');
  if (heart) { heart = heart.cloneNode(true); heart.setAttribute('aria-hidden', 'true'); pull.appendChild(heart); }
  pull.appendChild(ring); pull.appendChild(say);
  face.appendChild(box); face.appendChild(pull);
  /* the hotspot that sat on the pull gives way to the pull itself */
  [].forEach.call(face.querySelectorAll('.sa-hot'), function (h) { if (Math.abs(parseFloat(h.style.getPropertyValue('--hy')) - 21) < 2 && Math.abs(parseFloat(h.style.getPropertyValue('--hx')) - 51) < 2) h.style.display = 'none'; });

  var t = 0, anim = 0;
  function draw(v) {
    t = clamp(v);
    var live = t > 0.004;
    /* the opening is a long kite: its point rides on the pull, its shoulders spread under the collar */
    var yp = FROM + (TO - FROM) * t, a = 26 * (1 - Math.pow(1 - t, 2.4)), yw = Math.min(TOP + 4.5, yp);
    function kite(w, d) { return 'polygon(' + CX + '% ' + (TOP - d) + '%,' + (CX + w) + '% ' + yw + '%,' + CX + '% ' + (yp + d) + '%,' + (CX - w) + '% ' + yw + '%)'; }
    tape.style.clipPath = kite(a + 0.7, 0.9); inside.style.clipPath = kite(a, 0);
    var g = Math.max(0, a - 3.2), o = [CX + '% ' + (TOP - 4) + '%', (CX + a + 6) + '% ' + yw + '%', CX + '% ' + (yp + 6) + '%', (CX - a - 6) + '% ' + yw + '%'], n = [CX + '% ' + (TOP + 2.5) + '%', (CX + g) + '% ' + (yw + 1.5) + '%', CX + '% ' + Math.max(TOP + 2.5, yp - 6) + '%', (CX - g) + '% ' + (yw + 1.5) + '%'];
    rim.style.clipPath = 'polygon(evenodd,' + o.join(',') + ',' + o[0] + ',' + n.join(',') + ',' + n[0] + ')';
    tape.style.visibility = inside.style.visibility = live ? 'visible' : 'hidden';
    box.classList.toggle('is-live', live);
    tag.style.opacity = seg(t, 0.5, 0.85).toFixed(3);
    pull.style.top = yp + '%';
    [].forEach.call(face.querySelectorAll('.sa-hot'), function (h) { h.style.visibility = live ? 'hidden' : ''; });
  }
  function glide(to) {
    cancelAnimationFrame(anim);
    var from = t, t0 = performance.now(), ms = calm ? 1 : 260 + 420 * Math.abs(to - from);
    (function step(now) {
      var p = Math.min(1, (now - t0) / ms), e = 1 - Math.pow(1 - p, 3);
      draw(from + (to - from) * e);
      if (p < 1) anim = requestAnimationFrame(step);
    })(t0);
    pull.setAttribute('aria-pressed', to > 0.5 ? 'true' : 'false');
    pull.setAttribute('aria-label', to > 0.5 ? 'Zip the jacket back up' : 'Unzip the jacket');
  }
  function settle() { stage.classList.add('is-turned'); var front = stage.querySelector('[data-view=front]'); if (front) front.click(); }

  var held = false, moved = 0, y0 = 0, t0 = 0, span = 1;
  pull.addEventListener('pointerdown', function (e) {
    if (e.button) return;
    held = true; moved = 0; y0 = e.clientY; t0 = t; span = Math.max(40, face.getBoundingClientRect().height * (TO - FROM) / 100);
    cancelAnimationFrame(anim); pull.classList.add('is-used'); settle();
    try { pull.setPointerCapture(e.pointerId); } catch (err) {}
    e.preventDefault(); e.stopPropagation();
  });
  pull.addEventListener('pointermove', function (e) { if (!held) return; var d = e.clientY - y0; moved = Math.max(moved, Math.abs(d)); draw(t0 + d / span); });
  function drop() {
    if (!held) return; held = false;
    if (moved < 5) glide(t > 0.5 ? 0 : 1);            /* a tap or a key press opens or closes it */
    else glide(t > 0.55 ? 1 : 0);
  }
  pull.addEventListener('pointerup', drop); pull.addEventListener('pointercancel', drop);
  pull.addEventListener('click', function (e) { e.stopPropagation(); if (e.detail === 0) { pull.classList.add('is-used'); settle(); glide(t > 0.5 ? 0 : 1); } });
  /* turning the jacket zips it back up */
  [].forEach.call(stage.querySelectorAll('[data-view]'), function (b) { if (b.dataset.view !== 'front') b.addEventListener('click', function () { if (t > 0) glide(0); }); });
  stage.addEventListener('pointerdown', function (e) { if (t > 0 && !e.target.closest('button, a, input')) glide(0); });
  draw(0);
  /* the jacket holds still, front on, so the pull is the one invitation */
  window.addEventListener('load', function () { setTimeout(settle, 60); });

  /* light across the leather: follows the cursor, or the tilt of the phone, and drifts when left alone */
  var faces = [].slice.call(stage.querySelectorAll('.sa-stage__face')), first = home.currentSrc || home.src;
  function light() {
    faces.forEach(function (f) {
      var im = f.querySelector('img'), s = el('span', 'sa-sheen'), u = im && (im.currentSrc || im.src);
      if (!u) return;
      s.style.webkitMaskImage = s.style.maskImage = 'url(' + u + ')';
      if (im.width && im.offsetWidth && im.offsetWidth < f.offsetWidth - 2) { s.style.left = im.offsetLeft + 'px'; s.style.width = im.offsetWidth + 'px'; }
      f.appendChild(s);
    });
    var lx = 32, ly = 26, tx = 32, ty = 26, idle = true, seen = false, raf = 0, last = 0;
    function put() { stage.style.setProperty('--lx', lx.toFixed(1) + '%'); stage.style.setProperty('--ly', ly.toFixed(1) + '%'); }
    function loop(now) {
      raf = 0; if (!seen) return;
      if (idle && !calm) { var k = now / 1000; tx = 50 + Math.sin(k * 0.45) * 30; ty = 34 + Math.cos(k * 0.31) * 16; }
      lx += (tx - lx) * 0.1; ly += (ty - ly) * 0.1; put();
      if ((idle && !calm) || Math.abs(tx - lx) > 0.2 || Math.abs(ty - ly) > 0.2) raf = requestAnimationFrame(loop);
    }
    function go() { if (!raf && seen) raf = requestAnimationFrame(loop); }
    stage.addEventListener('pointermove', function (e) {
      var r = face.getBoundingClientRect(); if (!r.width) return;
      idle = false; last = Date.now(); tx = (e.clientX - r.left) / r.width * 100; ty = (e.clientY - r.top) / r.height * 100; go();
    });
    stage.addEventListener('pointerleave', function () { idle = true; go(); });
    /* phones that report tilt without asking permission */
    if (window.DeviceOrientationEvent && typeof window.DeviceOrientationEvent.requestPermission !== 'function') {
      window.addEventListener('deviceorientation', function (e) {
        if (!seen || e.gamma === null || Date.now() - last < 1500) return;
        idle = false; tx = 50 + clamp((e.gamma + 30) / 60) * 60 - 30; ty = 34 + (clamp((e.beta - 20) / 50) - 0.5) * 40; go();
      });
    }
    if (window.IntersectionObserver) new IntersectionObserver(function (es) { seen = es[0].isIntersecting; stage.classList.toggle('is-lit', seen); go(); }, { threshold: 0.2 }).observe(stage);
    else { seen = true; stage.classList.add('is-lit'); go(); }
    put();
  }
  /* the light is masked to the jacket's own outline; only switch it on if that outline can be read */
  if (window.fetch && window.CSS && CSS.supports && (CSS.supports('mask-image', 'none') || CSS.supports('-webkit-mask-image', 'none'))) {
    fetch(first, { mode: 'cors' }).then(function (r) { if (r.ok) light(); }).catch(function () {});
  }
})();
